export const saveToLocalStorage = (key: string, value: string) => {
    localStorage.setItem(key, value);
};

export const getFromLocalStorage = (key: string): string | null => {
    return localStorage.getItem(key);
};

export const getJsonFromLocalStorage = <T>(key: string, fallback: T): T => {
    const storedValue = localStorage.getItem(key);
    if (storedValue === null) return fallback;

    try {
        return JSON.parse(storedValue) as T;
    } catch (error) {
        console.warn(`Ignoring invalid local storage value for "${key}"`, error);
        return fallback;
    }
};
